import { Pipe, PipeTransform } from '@angular/core';
import { Cms } from '@impact/data';

@Pipe({
  name: 'isExpanded'
})
export class IsExpandedPipe implements PipeTransform {

  transform(navigation: Cms.NavigationDto, currentUrl: string): boolean {
    return navigation.url === currentUrl ||
        navigation?.children?.some((childNavigation) => childNavigation.url === currentUrl)
  }

}
